<proffeo-ui-dialog [title]="'project-locations.modals.change-location-parent-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex items-center gap-2 rounded-lg hover:bg-proffeo-surface-muted pb-2">
      <mat-radio-button
        (change)="pickProjectRootAsParent()"
        [checked]="isRootParentSelected()"
        value=""
        class="shrink-0"
      />
      <span [class.font-semibold]="isRootParentSelected()">
        {{ 'project-locations.modals.parent-root-option' | translate }}
      </span>
    </div>
    @for (availableLocation of availableLocations(); track availableLocation?.id) {
      <proffeo-select-location-list-item
        (locationSelected)="pickLocationAsParent($event)"
        [excludedLocationIds]="excludedParentLocationIds()"
        [location]="availableLocation"
        [selectedLocation]="selectedNewParent()"
      ></proffeo-select-location-list-item>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="isSaving()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
